<template>
  <div class="home-service" style="padding-top:100px;" >
        <UiHeading
          :h="'1'"
          :type="'E2'"
          :text="'Services'"
          :subTitle="'事業内容'"
          id="service"
        />

        <div class="box-cover">
          <UiBox :imgPath="'RobecityInternational-hp-top-007.jpg'" :type="'A2'" :imgName="'テスト'" :linkPath="'https://rci85.com/'" :text="'陸送、レッカー、レンタカー、中古車の買取、中古車の販売、オークション代行、車検・修理・整備、各種保険のご提案まで、自動車関連のサービスをワンストップで提供しています。お車のことならR.C.I.へご相談ください。'" class="box" :boxTitle="`自動車の関連事業`"/>
          <UiBox :imgPath="'RobecityInternational-hp-top-008.webp'" :type="'A3'" :imgName="'テスト'" :text="'沖縄県北部にてスキンダイビング、シュノーケリングツアー、パラセーリング、バナナボートをはじめとする様々なマリンスポーツ事業を行っております。'" class="box space-50-bm" :boxTitle="`マリンスポーツ事業`"/>
          <UiBox :imgPath="'RobecityInternational-hp-top-004.jpg'" :type="'A3'" :imgName="'テスト'" :text="'高級ワインのネットでの小売、店舗やホームパーティへのワインソムリエの派遣サービスを行っています。ワインのある豊かな生活をサポートしています。'" class="box space-50-bm" :boxTitle="`アルコール類の販売事業`"/>
          <UiBox :imgPath="'RobecityInternational-hp-top-005.jpg'" :type="'A2'" :imgName="'テスト'" :linkPath="'http://www.tanning-hotdog.jp/'" :text="'名古屋栄のテレビ塔のそばで、日焼けサロンHotDogの運営を行っています。短時間で小麦色の肌になれるマシーンを揃えています。'" class="box" :boxTitle="`日焼けサロン事業`"/>
        </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiHeading from "@/components/Ui/Heading.vue";
import UiBox from '../Ui/Box.vue';

export default {
  name: "HomeService",
  components: {
    UiHeading,
     UiBox,
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.home-service{
  background-color: var(--main);
  ::v-deep p{
    color: var(--sub2)!important;
  }
}
.box-cover{
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
.box{
  width: 48%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
}
</style>
